export default __webpack_public_path__ + "static/media/BrainBreak cards73.926f102a.png";